<script>
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators";
import { search_option } from "../../../helpers/lists";
import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import ArtistFormServices from "../../../services/artist_form.js";
import AlertError from "@/components/alert_error";
import getQrCode from "../../../helpers/qrCode.js";

export default {
  components: {
    AlertError,
    "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      results: [],

      // vuelidate
      search_option_id: "",
      inputSearchByPhone: "",
      inputSearchByName: "",
      inputSearchBySerial: "",

      //lists
      list_search_option: search_option,

      submitted: false,
      loadingButton: false,
      showAlert: false,
      notFound: false,
      isPrintedInformation: false,
    };
  },
  validations: {
    search_option_id: { required },
    inputSearchByName: {
      required: requiredIf(function () {
        return this.search_option_id == 1;
      }),
      minLength: minLength(6),
      maxLength: maxLength(50),
    },
    inputSearchByPhone: {
      required: requiredIf(function () {
        return this.search_option_id == 2;
      }),
      minLength: minLength(4),
      maxLength: maxLength(20),
    },
    inputSearchBySerial: {
      required: requiredIf(function () {
        return this.search_option_id == 3;
      }),
      minLength: minLength(10),
      maxLength: maxLength(10),
    },

    form: ["search_option_id", "inputSearchByName", "inputSearchByPhone", "inputSearchBySerial"],
  },
  methods: {
    getQrCode,
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    resetForm() {
      this.errors = [];
      this.results = [];
      this.loadingButton = false;
      this.submitted = false;
      this.notFound = false;
    },
    isFound() {
      return Array.isArray(this.results) && this.results.length > 0;
    },
    notfoundResult() {
      this.resetForm();
      this.notFound = true;
    },
    search() {
      this.resetForm();
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$error) return;

      let data = {
        search_type: this.search_option_id,
      };
      switch (this.search_option_id) {
        case 1:
          data.search_name = this.inputSearchByName;
          break;
        case 2:
          data.search_phone = this.inputSearchByPhone;
          break;
        case 3:
          data.search_serial = this.inputSearchBySerial;
          break;
      }

      // to form submit after this
      this.loadingButton = true;

      ArtistFormServices.search(data)
        .then((response) => {
          this.results = response.data.data.map((x) => {
            return {
              Id: x.serial_number,
              fullName: x.full_name,
              date: x.created_at,
              qr_code: this.getQrCode(x.uuid),
              artists: x.artists.map((a) => {
                return {
                  artwork_name: a.artwork_name,
                  main_name: a.sub.main["name_" + this.$i18n.locale],
                };
              }),
            };
          });
          //check if not found
          if (!this.isFound()) this.notfoundResult();

          this.loadingButton = false;
        })
        .catch((error) => {
          this.resetForm();
          this.handleError(error);
        });
    },
    // print card
    async printThis(id) {
      const el = document.getElementById("printcontent_" + id);
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  mounted() {},
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <section class="section con-all-page" id="features">
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-header text-center">
              <div class="con-logo">
                <img
                  height="60px"
                  src="@/assets/images/logo3.png"
                  loading="lazy"
                  alt="logo"
                />
                <a target="_blank" href="https://qadatalnasr.com"
                  ><h4>{{ $t("pages.search.title") }}</h4></a
                >
              </div>
              <p class="sub-title">{{ $t("pages.search.sub_title") }}</p>
            </div>
          </div>

          <div class="col-md-12" style="min-height: calc(100vh - 333px)">
            <b-form class="mb-5 px-3" @submit.prevent="search">
              <div class="row con-all-form">
                <div class="col-md-12">
                  <p>{{ $t("pages.search.note") }}</p>
                </div>
                <b-form-group
                  class="mb-3"
                  :class="search_option_id > 0 ? 'col-md-6' : 'col-md-12'"
                >
                  <label for="search_option_id">{{
                    $t("pages.search.form.search_option_id.label")
                  }}</label>
                  <select
                    class="form-control form-select"
                    id="search_option_id"
                    v-model="search_option_id"
                    :class="{ 'is-invalid': $v.search_option_id.$error }"
                  >
                    <option value="">
                      {{ $t("pages.search.form.search_option_id.default-option") }}
                    </option>
                    <option
                      v-for="search_option in list_search_option"
                      :value="search_option.id"
                      :key="search_option.id"
                    >
                      {{ search_option.name }}
                    </option>
                  </select>
                  <div v-if="$v.search_option_id.$error" class="invalid-feedback">
                    <span v-if="!$v.search_option_id.required">{{
                      $t("pages.search.form.search_option_id.validation.required")
                    }}</span>
                  </div>
                </b-form-group>

                <b-form-group
                  v-if="search_option_id == 1"
                  class="col-md-6 mb-3"
                  :label="$t('pages.search.form.inputSearchByName.label')"
                  label-for="inputSearchByName"
                >
                  <b-form-input
                    v-model="inputSearchByName"
                    :class="{
                      'is-invalid': submitted && $v.inputSearchByName.$error,
                    }"
                    id="inputSearchByName"
                    type="text"
                    :placeholder="$t('pages.search.form.inputSearchByName.placeholder')"
                  ></b-form-input>
                  <div
                    v-if="submitted && $v.inputSearchByName.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.inputSearchByName.required">{{
                      $t("pages.search.form.inputSearchByName.validation.required")
                    }}</span>
                    <span v-if="!$v.inputSearchByName.minLength">{{
                      $t("pages.search.form.inputSearchByName.validation.minLength")
                    }}</span>
                    <span v-if="!$v.inputSearchByName.maxLength">{{
                      $t("pages.search.form.inputSearchByName.validation.maxLength")
                    }}</span>
                  </div>
                </b-form-group>

                <b-form-group
                  v-if="search_option_id == 2"
                  class="col-md-6 mb-3"
                  :label="$t('pages.search.form.inputSearchByPhone.label')"
                  label-for="inputSearchByPhone"
                >
                  <b-form-input
                    v-model="inputSearchByPhone"
                    :class="{
                      'is-invalid': submitted && $v.inputSearchByPhone.$error,
                    }"
                    id="inputSearchByPhone"
                    type="number"
                    :placeholder="$t('pages.search.form.inputSearchByPhone.label')"
                  ></b-form-input>
                  
                  <div
                    v-if="submitted && $v.inputSearchByPhone.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.inputSearchByPhone.required">{{
                      $t("pages.search.form.inputSearchByPhone.validation.required")
                    }}</span>
                    <span v-if="!$v.inputSearchByPhone.minLength">{{
                      $t("pages.search.form.inputSearchByPhone.validation.minLength")
                    }}</span>
                    <span v-if="!$v.inputSearchByPhone.maxLength">{{
                      $t("pages.search.form.inputSearchByPhone.validation.maxLength")
                    }}</span>
                  </div>
                </b-form-group>

                <b-form-group
                  v-if="search_option_id == 3"
                  class="col-md-6 mb-3"
                  :label="$t('pages.search.form.inputSearchByPhone.label')"
                  label-for="inputSearchByPhone"
                >
                  <b-form-input
                      v-model="inputSearchBySerial"
                      :class="{
                        'is-invalid': submitted && $v.inputSearchBySerial.$error,
                      }"
                      id="inputSearchBySerial"
                      type="number"
                      :placeholder="$t('pages.search.form.inputSearchBySerial.label')"
                    ></b-form-input>
                    <div
                      v-if="submitted && $v.inputSearchBySerial.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.inputSearchBySerial.required">{{
                        $t("pages.search.form.inputSearchBySerial.validation.required")
                      }}</span>
                      <span v-if="!$v.inputSearchBySerial.minLength">{{
                        $t("pages.search.form.inputSearchBySerial.validation.minLength")
                      }}</span>
                      <span v-if="!$v.inputSearchBySerial.maxLength">{{
                        $t("pages.search.form.inputSearchBySerial.validation.maxLength")
                      }}</span>
                    </div>
                </b-form-group>

                <div class="col-md-12 mb-3">
                  <b-button
                    class="btn-search"
                    type="submit"
                    :disabled="this.loadingButton"
                  >
                    <b-spinner v-if="this.loadingButton" small></b-spinner>
                    <span v-else>
                      <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                      {{ $t("pages.search.form.buttonSearch.label") }}
                    </span>
                  </b-button>
                </div>
                <div v-if="notFound" class="col-md-12 mt-4">
                  <div class="text-center">
                    <h4>{{ $t("pages.search.no_result") }}</h4>
                  </div>
                </div>

                <div v-if="results.length > 0">
                  <div
                    class="text-center print-cover mt-5"
                    v-for="result in results"
                    :key="result.Id"
                  >
                    <div
                      class="card-print con-print text-center"
                      :id="'printcontent_' + result.Id"
                    >
                      <div class="header">
                        <h5>{{ $t("pages.search.title") }}</h5>
                        <p>
                          <strong>{{ $t("pages.search.card_info.name") }}</strong
                          >{{ result.fullName }}
                        </p>
                        <p>
                          <strong>{{ $t("pages.search.card_info.date") }}</strong
                          >{{ result.date }}
                        </p>
                        <p>
                          <strong>{{ $t("pages.search.card_info.form_number") }}</strong
                          >{{ result.Id }}
                        </p>
                      </div>
                      <div class="artwork text-center">
                        <h5>{{ $t("pages.search.card_info.artist_title") }}</h5>
                        <hr />
                        <ol class="centered-list mb-0">
                          <li v-for="artist in result.artists" :key="artist.id">
                            <p>
                              <span>{{ artist.main_name }}</span>
                              <i class="mdi mdi-chevron-left"></i>
                              <span>{{ artist.artwork_name }}</span>
                            </p>
                          </li>
                        </ol>
                      </div>
                      <qr-code class="qr-code" :text="result.qr_code"></qr-code>
                    </div>
                    <button
                      type="button"
                      id="btn3"
                      @click="printThis(result.Id)"
                      class="btn btn-save-qr btn-sm mt-3"
                    >
                      {{ $t("pages.search.card_info.save_button") }}
                    </button>
                  </div>
                </div>
              </div>
            </b-form>
          </div>
          <div class="col-lg-12">
            <!-- Footer start -->
            <footer class="landing-footer">
              <div class="container">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <img src="@/assets/images/logo.png" alt height="50" />
                    <span class="mx-2">{{ $t("pages.footer.title") }}</span>
                  </div>
                  <div class="col-md-6">
                    <p class="mt-1 text-md-end ltr-text d-sm-block mb-0">
                      {{ new Date().getFullYear() }} {{ $t("pages.footer.copy_right") }}
                    </p>
                  </div>
                </div>
              </div>
            </footer>
            <!-- Footer end -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->
  </div>
</template>
